import React from 'react';

const LoadingSpinner: React.FC = () => {
  return (
    <div className="page-loader">
      <div className="loader" aria-label="Loading..." />
    </div>
  );
};

export default LoadingSpinner;
